export default "https://a.travel-assets.com/partner-portal/laptop.737d25456e1a.svg";